import useFetch from "Hooks/useFetch";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const FooterNav = ({ t }) => {
  const { data: categories, fetchData } = useFetch("");

  useEffect(() => {
    fetchData("course-categories");
  }, []);
  // Custom FooterNavLink component for consistent styling
  const FooterNavLink = ({ to, children }) => {
    return (
      <Link to={to} className="text-white hover:text-primary transition-colors">
        {children}
      </Link>
    );
  };

  return (
    <nav className="w-full mt-6 uppercase">
      <ul className="flex flex-wrap justify-center lg:justify-between w-full gap-6 text-white">
        <FooterNavLink to="/">{t("navigation.home")}</FooterNavLink>

        {categories?.data?.map((category, index) => (
          <FooterNavLink key={index} to={`/courses/${category.slug}`}>
            {category.title}
          </FooterNavLink>
        ))}

        {/* <FooterNavLink to="/books">{t("navigation.books")}</FooterNavLink> */}
        {/* <FooterNavLink to="/products">{t("navigation.products")}</FooterNavLink> */}
        <FooterNavLink to="/about">{t("navigation.about")}</FooterNavLink>
        <FooterNavLink to="/contact">{t("navigation.contact")}</FooterNavLink>
      </ul>
    </nav>
  );
};

export default FooterNav;
